import React from 'react';
//import ReactDOM from 'react-dom';
import Pagination from 'rc-pagination';
import _en_US from 'rc-pagination/lib/locale/en_US';
import Loader from '../common/loader';
import Time from 'react-time';
import { Collapse } from 'react-collapse';
import AppActions from '../../actions/app-actions';
// material ui
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import ConfigCreate from './configcreate';
import pluralize from 'pluralize';
import Button from '@material-ui/core/Button';

import { getUserRoleFromJWT } from '../../helpers';

export default class ConfigList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
  }

  _getInitialState() {
    return {
      minHeight: 200,
      divHeight: 178,
      selectedRows: [],
      currentUserRole: getUserRoleFromJWT(),
    };
  }
  componentDidUpdate(prevProps) {
    var self = this;
    if (prevProps.configs.length !== this.props.configs.length) {
      self.setState({ selectedRows: [], expandRow: null, allRowsSelected: false });
    }
  }

  _adjustHeight() {
    // do this when number of configs changes
    var h = this.props.configs.length * 55;
    this.setState({ minHeight: h });
  }
  handleSubmit = (c) => {
    console.log('configlist - handleSubmit');
    console.log(c);
    if(this.props.handleSubmit) {
      this.props.handleSubmit(c);
    }
  };

  handleCancel = () => {
    this.setState({expandRow: null});
    console.log('configlist - handleCancel');
    if(this.props.handleCancel) {
      this.props.handleCancel();
    }
  };

  _expandRow(event, rowNumber) {
    var self = this;
    if (event && event.target && event.target.closest('input') && event.target.closest('input').hasOwnProperty('checked')) {
      return;
    }
    AppActions.setSnackbar('');
    var config = this.props.configs[rowNumber];
    if (this.state.expandRow === rowNumber) {
      rowNumber = null;
    }
    self.setState({ expandRow: rowNumber, config: config });
  }

  _adjustCellHeight(height) {
    this.setState({ divHeight: height + 85 });
  }
  
  _isSelected(index) {
    return this.state.selectedRows.indexOf(index) !== -1;
  }

  _onRowSelection(selectedRow) {
    const self = this;
    const { selectedRows } = self.state;
    const selectedIndex = selectedRows.indexOf(selectedRow);
    let updatedSelection = [];
    if (selectedIndex === -1) {
      updatedSelection = updatedSelection.concat(selectedRows, selectedRow);
    } else {
      selectedRows.splice(selectedIndex, 1);
      updatedSelection = selectedRows;
    }
    self.setState({ selectedRows: updatedSelection });
  }

  onSelectAllClick() {
    const self = this;
    let selectedRows = Array.apply(null, { length: this.props.configs.length }).map(Number.call, Number);
    if (self.state.selectedRows.length && self.state.selectedRows.length <= self.props.configs.length) {
      selectedRows = [];
    }
    self.setState({ selectedRows });
  }

  handleRemove = (e) => {
    console.log(e);
    let i, cfg;
    if(this.props.handleRemove) {
      for(i=0; i<e.length; i++) {
        let index = e[i];
        cfg = this.props.configs[index];
        this.props.handleRemove(cfg);
      }
    }
    //this.props.removeConfig(this.state.selectedRows);
  }

  onPageChange(page) {
    this.props.onPageChange(page);
  }

  render() {
    const self = this;
    const { pageLength, pageLoading, pageNo, pageTotal} = this.props;
    var pluralized = pluralize(this.props.type, this.state.selectedRows.length);
    var removeLabel = `Remove selected ${pluralized}`;
    var filteredConfigs = this.props.configs;
    var configs = filteredConfigs.map(
      function(config, index) {
        var self = this;
        var expanded = '';
        
        if (self.state.expandRow === index) {
          expanded = (
            <div className="float-right">
              <ConfigCreate
                open={true}
                edit={true}
                handleSubmit={this.handleSubmit}
                handleCancel={this.handleCancel}
                config={this.state.config}
                type={this.props.type}
              />
            </div>
          );
        }
        
        return (
          <TableRow
            key={config.id}
            hoverable={!expanded}
            className={expanded ? 'expand' : null}
            selected={this._isSelected(index)}
            onClick={event => self._expandRow(event, index)}
          >
            <TableCell padding="checkbox">
              <Checkbox
                style={expanded ? { paddingTop: '0', marginTop: '-4px' } : {}}
                checked={self._isSelected(index)}
                onChange={() => self._onRowSelection(index)}
              />
            </TableCell>
            <TableCell>
              {config.config_name || config.flavor_name || config.name}
            </TableCell>
            <TableCell>
              {config.config_flavor || config.type}
            </TableCell>
            <TableCell>
              {config.created_ts ? <Time value={config.created_ts} format="YYYY-MM-DD HH:mm" /> : '-'}
            </TableCell>
            <TableCell>
              {config.updated_ts ? <Time value={config.updated_ts} format="YYYY-MM-DD HH:mm" /> : '-'}
            </TableCell>
            <TableCell style={{ width: '0', padding: '0', overflow: 'visible' }}>
              <Collapse
                springConfig={{ stiffness: 210, damping: 20 }}
                onHeightReady={this._adjustCellHeight}
                className="expanded"
                isOpened={expanded ? true : false}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                {expanded}
              </Collapse>
            </TableCell>
          </TableRow>
        );
      }.bind(this)
    );

    return (
      <div className="margin-top-small">
        <div className="margin-bottom">
          <Table>
            <TableHead className="clickable" enableSelectAll={true}>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    onChange={() => self.onSelectAllClick()}
                  />
                </TableCell>
                <TableCell className="columnHeader" style={{ width: '22%' }} tooltip='Config Name'>
                  Name
                </TableCell>
                <TableCell className="columnHeader" style={{ width: '22%' }} tooltip='Protection Type'>
                  Type
                </TableCell>
                <TableCell className="columnHeader" style={{ width: '22%' }} tooltip='Creation Data'>
                  Date Created
                </TableCell>
                <TableCell className="columnHeader" style={{ width: '22%' }} tooltip='Last Upated'>
                  Last Updated
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{configs}</TableBody>
          </Table>
        </div>
        <Pagination
          className="margin-top"
          locale={_en_US}
          simple
          pageSize={pageLength}
          current={pageNo}
          total={pageTotal}
          onChange={e => self.onPageChange(e)}
        />
        {pageLoading ? (
          <div className="smallLoaderContainer">
            <Loader show={true} />
          </div>
        ) : null}
        <div>
          {this.state.selectedRows.length ? (
            <div className="fixedButtons">
              <div className="float-right">
                <span className="margin-right">
                  {this.state.selectedRows.length} {pluralize(this.props.type, this.state.selectedRows.length)} selected
                </span>
                <Button variant="contained" disabled={!this.state.selectedRows.length || (this.state.currentUserRole !== 'admin')} color="secondary" onClick={() => this.handleRemove(this.state.selectedRows)}>
                  {removeLabel}
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
